<template>
  <header class="step__header">
    <h3>
      <Icon
        v-if="isEnabled(currentStep - 1)"
        class="step__header-icon--previous"
        name="angle-left"
        @click="previousStep"
      />
      {{ $t(title) }}
      <Icon
        v-if="!isLast && isEnabled(currentStep + 1)"
        class="step__header-icon--next"
        name="angle-right"
        @click="nextStep"
      />
    </h3>
    <!-- <input type="text" v-model="test" /> -->
  </header>
</template>
<script>
import { mapGetters } from "vuex";
import { mapState } from "vuex";

export default {
  name: "BaseCertificationFormStepHeader",
  props: {
    v: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState("Form", ["currentStep"]),
    ...mapGetters("Form", ["title", "isFirst", "isLast", "isEnabled"])
  },
  methods: {
    // isEnabled(step) {
    //   return this.$store.dispatch('Form/isEnabled', step)
    // },
    previousStep: function() {
      this.v[`step${this.currentStep}`].$touch();
      this.$store.dispatch("Form/previousStep");
    },
    nextStep: function() {
      this.v[`step${this.currentStep}`].$touch();
      this.$store.dispatch("Form/nextStep");
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/_variables.scss";

.step__header {
  color: $col-polmed-navy;
  text-align: center;
  margin: 30px 0;

  h3 {
    display: inline-block;
    position: relative;
    margin: 0;
  }

  &-icon--previous,
  &-icon--next {
    position: absolute;
    top: 2px;
    width: 1em;
    height: 1em;
    color: $col-polmed-gray;
    cursor: pointer;

    path {
      fill: $col-polmed-gray;
      transition: all $transition-duration;
    }

    &:hover path {
      fill: $col-polmed-navy;
    }
  }

  &-icon--previous {
    left: -60px;
  }

  &-icon--next {
    right: -60px;
  }
}
</style>
